<template>
  <div class="wrapper">
    <div class="stepContainer">
      <el-steps :active="step" align-center>
        <!-- describeion="这是一段很长很长很长的描述性文字" -->

        <el-step title="报名信息" @click="step++"></el-step>
        <el-step title="填写报名信息"></el-step>
        <el-step title="主题"></el-step>
        <el-step title="设置"></el-step>
        <el-step title="发布链接"></el-step>
      </el-steps>
    </div>
    <div class="applyContainer">
      <div class="applyContent" v-show="step == 0" key="applyContent1">
        <el-image
          class="applyLogo"
          :src="applyData.logoUrl"
          fit="contain"
        ></el-image>
        <input
          type="text"
          v-model="applyData.name"
          class="titleInput"
          @focus="inputFocus"
          @blur="inputBlur"
        />

        <div
          class="applyDescribe"
          v-html="applyData.describe"
          v-show="!applyData.ifEditDescribe"
          @click="showEditor"
        ></div>
        <div
          ref="applyDescribe"
          id="applyDescribe"
          class="applyDescribe"
          v-show="applyData.ifEditDescribe"
        ></div>
        <input type="text" class="btnInput" v-model="applyData.submitFont" />
      </div>
      <div
        class="editContent"
        :style="{ backgroundImage: bgComputed }"
        v-if="step == 1 || step == 2"
        @click="choosingForm.customizeId = 0"
      >
        <div class="actSide" v-show="step == 1">
          <h2 style="margin: 20px">可选择项(点击添加或移除)</h2>
          <div class="selectBox">
            <div
              :class="[
                'selectCell',
                keyValueSelected.includes(item.customizeId)
                  ? 'labelChosen'
                  : '',
              ]"
              v-for="(item, index) in keyValueList"
              :key="'keyVal' + index"
              @click="keyValueClick(item)"
            >
              <div class="keyvalFont">{{ item.name }}</div>
              <i
                class="el-icon-edit-outline"
                @click.stop="editKeyval(item)"
                v-if="item.type == 2"
              ></i>
              &nbsp;
              <i
                class="el-icon-delete"
                @click.stop="deleteKeyval(item)"
                v-if="item.type == 2"
              ></i>
            </div>
          </div>
          <el-button
            class="appendKeyval"
            @click.stop="editKeyval(false)"
            type="info"
            >添加新的项</el-button
          >
        </div>
        <div class="actSide" v-show="step == 2" key="actSide2">
          <div class="switchBar">
            <div
              :class="[
                'switchCell',
                bgData.type == 1 ? 'switchCellChosen' : '',
              ]"
              @click="bgData.type = 1"
            >
              主题背景
            </div>
            <div
              :class="[
                'switchCell',
                bgData.type == 2 ? 'switchCellChosen' : '',
              ]"
              @click="bgData.type = 2"
            >
              自定义
            </div>
          </div>
          <div class="bgChooseBox" v-show="bgData.type == 1">
            <div
              class="bgCell"
              v-for="(item, index) in bgList"
              :key="'applyBg' + index"
              @mouseenter="item.ifAct = true"
              @mouseleave="item.ifAct = false"
              :style="{
                backgroundImage: 'url(' + item.url + ')',
                border:
                  item.url == (applyData.image || '')
                    ? '1px solid #409EFF'
                    : '',
              }"
            >
              <img src="@/assets/img/applyBox.png" class="contentInBg" alt="" />
              <div class="toBlack" v-show="item.ifAct">
                <el-button type="primary" @click="applyData.image = item.url"
                  >选择此主题</el-button
                >
              </div>
            </div>
          </div>
          <div class="bgChooseBox" v-show="bgData.type == 2">
            <div
              class="bgCell"
              v-if="bgData.myBg"
              @mouseenter="bgData.ifAct = true"
              @mouseleave="bgData.ifAct = false"
              :style="{
                backgroundImage: 'url(' + bgData.myBg + ')',
                border:
                  bgData.myBg == (applyData.image || '')
                    ? '1px solid #409EFF'
                    : '',
              }"
            >
              <img src="@/assets/img/applyBox.png" class="contentInBg" alt="" />
              <div class="toBlack" v-show="bgData.ifAct">
                <el-button type="primary" @click="applyData.image = bgData.myBg"
                  >选择此主题</el-button
                >
              </div>
            </div>
            <!-- <el-image fit="contain" class="diyBg" :src="bgData.myBg"></el-image> -->
            <br />
            <el-upload
              ref="upload"
              action
              :http-request="uploadBg"
              :show-file-list="false"
              :auto-upload="true"
              :headers="{ Authorization: getStore('accessToken') }"
            >
              <el-button size="mini" type="primary">上传背景</el-button>
              <el-button
                size="mini"
                type="primary"
                v-if="bgData.myBg"
                plain
                @click.stop="
                  bgData.myBg = '';
                  applyData.image = bgData.myBg;
                "
                >删除背景</el-button
              >
            </el-upload>
          </div>
        </div>
        <div class="showSide">
          <h2>填写报名信息</h2>
          <p class="greyFont">*请务必完整填写信息并核对</p>
          <transition-group name="flip-list">
            <div
              class="inputBar"
              :style="
                choosingForm.customizeId == item.customizeId
                  ? 'border:solid 2px #36aafd'
                  : ''
              "
              @click.stop="choosingForm.customizeId = item.customizeId"
              v-for="(item, index) in applyData.formList"
              :draggable="item == draggingItem"
              @mousedown="draggingItem = item"
              @dragover="draggingChange(item)"
              :key="'keyvalue' + item.customizeId"
            >
              <div class="keyvalBar">
                <div class="label">{{ item.name }}</div>
                <div class="content">
                  <div class="inputValue">
                    <i
                      class="el-icon-caret-bottom selectIcon"
                      v-if="item.form == 2"
                    ></i>
                  </div>

                  <input
                    type="text"
                    class="informationInput"
                    v-model="item.information"
                    placeholder="请输入提示信息"
                    v-if="item.ifInformation"
                  />
                  <!-- <el-input
                    size="mini"
                    
                  ></el-input> -->
                </div>
              </div>
              <div
                class="actBar"
                v-show="choosingForm.customizeId == item.customizeId"
              >
                <el-checkbox v-model="item.ifInformation"
                  >添加提示信息</el-checkbox
                >
                <el-checkbox
                  v-model="item.isRequired"
                  :true-label="1"
                  :false-label="0"
                  >是否为必填项</el-checkbox
                >
                <br />输入方式：
                <el-radio-group v-model="item.form" size="small">
                  <el-radio :label="1" border>输入</el-radio>
                  <el-radio :label="2" border>选择</el-radio>
                </el-radio-group>
                <br />
                <div class="selectValueContainer" v-if="item.form == 2">
                  <el-tag
                    :key="opt"
                    v-for="opt in item.optionList"
                    closable
                    :disable-transitions="false"
                    @close="
                      item.optionList.splice(
                        item.optionList.findIndex((val) => val == opt),
                        1
                      )
                    "
                  >
                    {{ opt }}
                  </el-tag>
                  <el-input
                    class="input-new-tag"
                    v-if="selectData.ifShow"
                    v-model="selectData.value"
                    ref="selectOptionInput"
                    size="small"
                    @keyup.enter.native="
                      selectData.value || selectData.value === 0
                        ? item.optionList.push(selectData.value)
                        : '';
                      selectData.ifShow = false;
                    "
                    @blur.stop="
                      selectData.value || selectData.value === 0
                        ? item.optionList.push(selectData.value)
                        : '';
                      selectData.ifShow = false;
                    "
                  >
                  </el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="addOption"
                    >添加选项</el-button
                  >
                </div>
              </div>
            </div></transition-group
          >
          <div class="submitBtn">提交信息</div>
        </div>
      </div>
      <div class="settingContainer" v-if="step == 3">
        <h1>报名设置</h1>
        <div class="inputBar" style="width: 420px">
          <div class="smallFont">请选择注册到哪个组</div>
          <treeinput
            :questionTypeTree="studentGroupTree"
            @treeEvent="studentGroupTreeEvent"
            :currentNodeId="applyData.groupId"
          ></treeinput>
        </div>
        <div class="inputBar">
          人数上限：
          <el-input v-model="applyData.maxTotal" size="mini"></el-input>
          人
        </div>
        <div class="inputBar">
          报名费用：<el-input v-model="applyData.cost" size="mini"></el-input>
        </div>
        <div class="inputBar">
          报名时间：<el-date-picker
            size="mini"
            v-model="applyTimeRange"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </div>
        <div class="inputBar">
          报名没开始时提示语<br />
          <el-input
            v-model="applyData.unstartedDec"
            size="mini"
            class="longElInput"
          ></el-input>
        </div>
        <div class="inputBar">
          报名结束时提示语<br />
          <el-input
            v-model="applyData.completeDec"
            size="mini"
            class="longElInput"
          ></el-input>
        </div>
        <div class="inputBar">
          报名成功提示语<br />
          <el-input
            v-model="applyData.succeedDec"
            size="mini"
            class="longElInput"
          ></el-input>
        </div>
        <div class="inputBar">
          报名失败提示语<br />
          <el-input
            v-model="applyData.failDec"
            size="mini"
            class="longElInput"
          ></el-input>
        </div>

        <div class="inputBar">
          报名成功后跳转到指定页面<br />
          跳转方式<el-radio-group v-model="applyData.isSkip" size="mini">
            <el-radio :label="1">不跳转</el-radio>
            <el-radio :label="2">手动跳转</el-radio>
            <el-radio :label="3">自动跳转</el-radio> </el-radio-group
          ><br />
          <span v-if="applyData.isSkip != 1">跳转页面</span>
          <!-- <el-radio-group
            size="mini"
            v-model="applyData.skipHtml"
            v-if="applyData.isSkip != 1"
          > -->
          <el-radio
            :label="1"
            size="mini"
            v-model="applyData.skipHtml"
            v-if="applyData.isSkip != 1"
            >指定试卷</el-radio
          >
          <el-select
            size="mini"
            v-model="applyData.examId"
            style="width: 265px"
            v-if="applyData.skipHtml == 1 && applyData.isSkip != 1"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in paperList"
              :key="item.exName"
              :label="item.exName"
              :value="item.id"
            >
            </el-option> </el-select
          ><br />&emsp;&emsp;&emsp;&nbsp;&nbsp;&nbsp;
          <el-radio
            :label="2"
            size="mini"
            v-model="applyData.skipHtml"
            v-if="applyData.isSkip != 1"
            ><span>指定链接</span> </el-radio
          ><br />
          <div v-if="applyData.skipHtml == 2 && applyData.isSkip != 1">
            &emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;
            <el-input
              v-model="applyData.skipUrl"
              size="mini"
              class="longElInput"
            ></el-input>
          </div>

          <div v-if="applyData.isSkip == 2">
            按钮标题：<el-input
              v-model="applyData.buttonName"
              size="mini"
            ></el-input>
          </div>
          <el-checkbox
            v-model="applyData.isShare"
            :true-label="1"
            :false-label="0"
            >显示分享按钮</el-checkbox
          >
          <div v-if="applyData.isShare == 1">
            设置分享语<br />
            <el-input
              class="longElInput"
              v-model="applyData.shareDec"
            ></el-input>
          </div>
          <br />
          <el-checkbox
            v-model="applyData.isOpen"
            :true-label="1"
            :false-label="0"
            >开启滑动验证</el-checkbox
          >
        </div>
      </div>
      <div v-if="step == 4" class="settingContainer">
        <h2 style="text-align: center">发布链接</h2>
        <div class="shareContainer">
          <div class="urlSide" style="display: inline-block; width: 50%">
            <h3>方式一：分享报名链接</h3>
            <el-input
              style="width: 96%; margin: 10px 4% 10px 0"
              :value="shareApplyUrl"
              disabled
            ></el-input>
            <br />
            <el-button type="primary" @click="copyText">复制</el-button>
            <el-button type="primary" plain @click="jumpTo">打开</el-button>
          </div>
          <div class="qrcodeSide" style="display: inline-block; width: 30%">
            <h3>方式二：扫码报名</h3>

            <vue-qr :text="shareApplyUrl" id="qrcodeImg"></vue-qr>
            <!--  -->
            <br />
            <el-button
              type="text"
              icon="el-icon-download"
              @click="downloadQrcode"
              >下载二维码</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="actBar">
      <el-button type="primary" plain @click="step--" v-if="step > 0"
        >上一步</el-button
      >
      <el-button type="primary" @click="$nextTick(nextStep)" v-if="step < 4"
        >下一步</el-button
      >
      <el-button type="info" plain @click="nextStep({ complete: true })">
        完成</el-button
      >
    </div>
    <el-dialog
      title="编辑考生收集字段名"
      :visible.sync="keyvalEdit.ifShow"
      width="30%"
      append-to-body
    >
      <el-input v-model="keyvalEdit.value"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="keyvalEdit.ifShow = false">取消</el-button>
        <el-button type="primary" @click="keyvalEditConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from "wangeditor";
import treeinput from "@/component/tree/treeInput.vue";
import vueQr from "vue-qr";
import { Base64 } from "@/libs/js/base64.js";

import {
  getStudentGroup,
  deleteStudentGroup,
  editStudentGroup,
  createStudentGroup,
  getSignupLabelList,
  deleteSignupLabel,
  createSignupLabel,
  getApplyData,
  deleteApply,
  updateApply,
  createApply,
} from "@/api/examination/student.js";
import { getPaperList } from "@/api/examination/examination.js";
export default {
  data() {
    return {
      applyData: {
        name: "报名啦",
        describe:
          "<p><b>报名说明：</b></p><p><font color='#999'>请务必在提交网上报名信息之前仔细核对个人信息。</font><b><br></b></p>",
        logoUrl:
          "https://userfile.youkaoshi.cn/userdata/3697410/img/brand-20200618103114_b8woyu.png",
        ifEditDescribe: false,
        submitFont: "立即报名",
        image: "",
        formList: [],
        ///////////
        groupId: "",
        maxTotal: 100,
        cost: 100,
        startTime: "",
        endTime: "",
        unstartedDec: "unstartedDec",
        completeDec: "completeDec",
        succeedDec: "succeedDec",
        failDec: "failDec",
        isSkip: 1,
        skipHtml: 1,
        skipUrl: "skipUrl",
        examId: 2,
        buttonName: "前往考试",
        isShare: 0,
        shareDec: "快来注册吧！",
        isOpen: 0,
      },
      selectData: {
        ifShow: false,
        value: "",
      },
      applySetting: {},
      keyValueList: [],
      keyvalEdit: {
        ifShow: false,
        value: "",
        item: "",
      },
      choosingForm: { customizeId: 0 },
      bgList: [
        { ifAct: false, url: "" },
        {
          ifAct: false,
          url: "https://ns-strategy.cdn.bcebos.com/ns-strategy/upload/fc_big_pic/part-00667-1588.jpg",
        },
      ],
      bgData: {
        type: 1,
        myBg: "",
        ifAct: false,
      },
      studentGroupTree: [],
      draggingItem: null,
      lastItem: null,
      step: 0,
      temporaryTree: "",
      needUpdate: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      applyTimeRange: [],
      paperList: [],
      Base64: new Base64(),
    };
  },
  watch: {
    applyTimeRange(val) {
      console.log("时间变了", val);
      [this.applyData.startTime, this.applyData.endTime] = val;
    },
    applyData: {
      handler(newName, oldName) {
        console.log("数据变了");
        this.needUpdate = true;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    keyValueSelected() {
      return this.applyData.formList.map((item) => item.customizeId);
    },
    bgComputed() {
      return "url(" + this.applyData.image + ")";
    },
    shareApplyUrl() {
      let query = this.Base64.encode(`applyId-${this.applyData.id}`);
      return `${document.location.protocol}//${document.location.host}/apply/#/?${query}`;
      // return `http://cbtest.cbstudy.cn:8060/apply/#/?${query}`;
    },
  },
  components: { treeinput, vueQr },
  created() {},
  mounted() {
    if (this.$route.query.applyId) {
      getApplyData({ id: parseInt(this.$route.query.applyId) }).then((data) => {
        this.applyTimeRange = [data.startTime || "", data.endTime || ""];
        data.formList.forEach((item) => {
          item.ifInformation = item.information ? true : false;
          item.optionList = Boolean(item.options)
            ? item.options.split(",")
            : [];
        });
        Object.assign(this.applyData, data);
        console.log(data);
        setTimeout(() => {
          this.needUpdate = false;
        });
      });
    }
    getPaperList({
      groupId: 0,
      // status: "",
      pageSize: 1000,
      jumpPage: 1,
      // total: 0,
      // queryExamName: "",
    }).then((data) => {
      this.paperList = data.respList;
      console.log(data);
    });
    // this.editorInit();
    this.studentGroupInit();
    this.signupLabelListInit();
  },
  methods: {
    addOption() {
      this.selectData.ifShow = true;
      this.selectData.value = "";
      this.$nextTick(() => {
        this.$refs.selectOptionInput[0].$refs.input.focus();
      });
    },
    studentGroupTreeEvent(eventDetail, data) {
      switch (eventDetail.type) {
        //       deleteStudentGroup,
        // editStudentGroup,
        // createStudentGroup,
        case "rename":
          editStudentGroup({
            id: eventDetail.contextData.id,
            // parentId: eventDetail.contextData.parentId,
            groupName: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("修改成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteStudentGroup({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );
          break;
        case "append":
          createStudentGroup({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("创建成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$Message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          editStudentGroup({
            id: eventDetail.id,
            parentId: eventDetail.parentId,
            // groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;
        case "chosen":
          console.log(eventDetail);
          this.settingData.studentGroupChosen = eventDetail.value;
          break;
        case "select":
          this.temporaryTree = eventDetail.value;
          break;
        case "confirm":
          // this.examinationType = this.temporaryTree;
          this.applyData.groupId = this.temporaryTree.id;
          break;
        default:
          break;
      }
    },
    nextStep(options) {
      setTimeout(() => {
        this.nextStep2(options);
      });
    },
    nextStep2(options) {
      if (this.ifEditDescribe) {
        this.hideEditor();
      }
      if (!this.step && !this.$route.query.applyId) {
        if (this.needUpdate) {
          createApply({
            name: this.applyData.name,
            describe: this.applyData.describe,
          }).then(
            (data) => {
              console.log(data);
              data.formList.forEach((item) => {
                item.ifInformation = item.information ? true : false;
              });
              this.applyData = data;
              this.needUpdate = false;
              this.step++;
            },
            (err) => {
              this.$message.error(err);
            }
          );
        } else {
          this.$message.warning("请修改报名标题");
        }
      } else {
        if (!this.applyData.groupId && this.step == 3) {
          this.$message.error("请选择学生分组");
          return;
        }
        if (this.needUpdate) {
          // console.log(JSON.stringify(this.applyData));
          this.applyData.formList.forEach((item, index) => {
            item.sort = index + 1;
            item.information = item.ifInformation ? item.information : "";
            item.options = item.optionList ? item.optionList.toString() : "";
          });

          updateApply(this.applyData).then((data) => {
            console.log(data);
            this.needUpdate = false;
            if (options && options.complete) {
              this.$message.success("保存成功");
              setTimeout(() => {
                this.$router.push({ name: "applyList" });
              }, 600);
            } else {
              this.step++;
            }
          });
          // this.step++;
        } else {
          if (options && options.complete) {
            this.$router.push({ name: "applyList" });
          } else {
            this.step++;
          }
        }
      }
    },
    draggingChange(item) {
      let keyvalList = this.applyData.formList;
      if (item !== this.draggingItem && this.lastItem != item) {
        if (keyvalList.indexOf(this.draggingItem) > keyvalList.indexOf(item)) {
          keyvalList.splice(keyvalList.indexOf(this.draggingItem), 1);
          keyvalList.splice(keyvalList.indexOf(item), 0, this.draggingItem);
        } else {
          keyvalList.splice(keyvalList.indexOf(this.draggingItem), 1);
          keyvalList.splice(keyvalList.indexOf(item) + 1, 0, this.draggingItem);
        }
      }
      this.lastItem = item;
    },
    editKeyval(item) {
      if (item) {
        this.keyvalEdit.value = item.name;
        this.keyvalEdit.item = item;
      } else {
        this.keyvalEdit.value = "";
        this.keyvalEdit.item = null;
      }
      this.keyvalEdit.ifShow = true;
    },
    deleteKeyval(item) {
      if (
        this.applyData.formList.some(
          (keyval) => keyval.customizeId == item.customizeId
        )
      ) {
        this.applyData.formList = this.applyData.formList.filter(
          (keyval) => keyval.customizeId != item.customizeId
        );
      }
      console.log(item);
      deleteSignupLabel({ id: item.customizeId }).then(() => {
        this.signupLabelListInit();
        this.applyData.formList.forEach((item, index) => {
          item.sort = index + 1;
          item.information = item.ifInformation ? item.information : "";
        });
        updateApply(this.applyData).then((data) => {
          this.needUpdate = false;
        });
      });
      // this.keyValueList.splice(this.keyValueList.indexOf(item), 1);
    },
    keyvalEditConfirm() {
      if (this.keyvalEdit.item) {
        createSignupLabel({
          customize: this.keyvalEdit.value,
          id: this.keyvalEdit.item.customizeId,
        }).then(() => {
          this.signupLabelListInit(this.keyvalEdit.item.customizeId);
          this.$message.success("修改成功");
        });
        // Object.assign(this.keyvalEdit.item, {
        //   label: this.keyvalEdit.value,
        //   key: this.keyvalEdit.value,
        // });
      } else {
        createSignupLabel({ customize: this.keyvalEdit.value }).then(() => {
          this.signupLabelListInit();
          this.$message.success("添加成功");
        });
        // this.keyValueList.push({
        //   label: this.keyvalEdit.value,
        //   key: this.keyvalEdit.value,
        //   value: "",
        //   type: "text",
        // });
      }

      this.keyvalEdit.ifShow = false;
    },
    keyValueClick(item) {
      if (item.isMust) {
        return;
      }
      if (
        this.applyData.formList.some(
          (keyval) => keyval.customizeId == item.customizeId
        )
      ) {
        this.applyData.formList = this.applyData.formList.filter(
          (keyval) => keyval.customizeId != item.customizeId
        );
      } else {
        // let pushKeyval = {};
        // Object.assign(pushKeyval, item);
        // delete pushKeyval.id;
        this.applyData.formList.push(item);
      }
    },
    inputFocus(e) {
      e.target.style.borderBottom = "1px solid #999";
    },
    inputBlur(e) {
      e.target.style.borderBottom = "none";
    },
    signupLabelListInit(editId) {
      getSignupLabelList().then((data) => {
        data.forEach((item) => {
          item.customizeId = item.id;
          item.information = "";
          item.ifInformation = false;
          delete item.id;
        });
        data.forEach((item) => {
          item.optionList = item.options ? item.options.split(",") : [];
        });

        if (editId) {
          this.applyData.formList.forEach((form) => {
            if (form.customizeId == editId) {
              form.name = data.find((item) => item.customizeId == editId).name;

              // Object.assign(
              //   form,
              //   data.find((item) => item.customizeId == editId)
              // );
            }
          });
        }
        this.keyValueList = data;
        console.log(data);
      });
    },
    showEditor() {
      this.editorInit();
      this.applyDescribeEditor.txt.html(this.applyData.describe);
      this.applyData.ifEditDescribe = true;
      // console.log(this.applyData.describe);
    },
    hideEditor() {
      this.applyData.describe = this.applyDescribeEditor.txt.html();
      console.log("hhhhhhhhh", this.applyData.describe);
      this.applyData.ifEditDescribe = false;
    },
    editorInit() {
      let applyDescribeEditor = new Editor(this.$refs.applyDescribe);
      applyDescribeEditor.config.menus = editorMenus;
      applyDescribeEditor.config.showFullScreen = false;

      applyDescribeEditor.config.onblur = (newHtml) => {
        console.log("bbbbbbbbbbbbbbbbbbbbbbbbb", newHtml);
        this.applyData.ifEditDescribe = false;
        this.applyData.describe = newHtml;
      };
      // applyDescribeEditor.config.onchange = function (newHtml) {
      //   console.log("change 之后最新的 html", newHtml);
      // };
      applyDescribeEditor.create();
      if (this.applyData.describe) {
        applyDescribeEditor.txt.html(this.applyData.describe);
      }

      this.applyDescribeEditor = applyDescribeEditor;
    },
    studentGroupInit() {
      getStudentGroup().then((data) => {
        this.studentGroupTree = data;
        // console.log(data);
      });
    },
    jumpTo() {
      window.open(this.shareApplyUrl, "_blank");
    },
    uploadBg(e) {
      console.log("上传", e.file);
      this.$oss
        .put(e.file.uid + "." + e.file.type.split("/")[1], e.file)
        .then((data) => {
          console.log(data);
          this.bgData.myBg = data.url;
          this.applyData.image = data.url;
        });
    },
    clearDiyBg() {
      console.log(this.applyData.image, this.bgData.myBg);
      this.bgData.myBg = "";
      if (this.bgData.myBg == this.applyData.image) {
        this.applyData.image = this.bgData.myBg;
      }
    },
    downloadQrcode: function (imgsrc, name) {
      var image = new Image();

      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL(); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || new Date().getTime(); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = document.getElementById("qrcodeImg").src;
    },
    copyText() {
      console.log(this.shareApplyUrl);
      var input = document.createElement("input");
      input.value = this.shareApplyUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
  },
};
const editorMenus = [
  //   "head", // 标题
  "bold", // 粗体
  "fontSize", // 字号
  "fontName", // 字体
  "italic", // 斜体
  "underline", // 下划线
  "strikeThrough", // 删除线
  "foreColor", // 文字颜色
  "backColor", // 背景颜色
  //   "link", // 插入链接
  // "code", // 插入代码
  // "undo", // 撤销
  // "redo", // 重复
  "list", // 列表
  "justify", // 对齐方式
  // "quote", // 引用
  "image", // 插入图片

  "video", // 插入视频
  "table", // 表格
];
</script>

<style scoped lang="less">
.wrapper {
  text-align: none;
  .stepContainer {
    background: #fff;
    padding: 20px 0;
  }
  .applyContainer {
    // margin: 30px;
    .applyContent {
      position: relative;
      width: 60%;
      height: auto;
      padding: 30px 20px 120px 20px;
      min-height: 600px;
      background-color: #fff;
      border-radius: 40px !important;
      border: solid 1px #e6e6e6;
      margin: 20px auto;
      min-width: 600px;
      text-align: center;
      .applyLogo {
        display: block;

        width: 30%;
        min-width: 160px;
        max-height: 48px;
        height: 80px;
        margin: auto;
        object-fit: contain;
      }
      .titleInput {
        border: none;
        display: block;
        line-height: 30px;
        margin: 40px auto;
        outline: none;
        width: 90%;
        text-align: center;
        font-size: 30px;
      }
      .applyDescribe {
        margin: 0 60px;
        text-align: initial;
      }
      .btnInput {
        text-align: center;
        padding: 9px 30px;
        box-shadow: 0px 5px 30px 0px #36aafd;
        border-radius: 40px;
        background-color: #36aafd;
        color: #ffffff;
        width: 300px;
        background-image: linear-gradient(229deg, #36aafd 0%, #387dfe 100%);
        height: 45px;
        font-size: 17px;
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        border: none;
        outline: none;
      }
    }
    .editContent {
      display: flex;

      background-size: cover;
      .actSide {
        // width: 300px;
        width: 25%;
        // border: 1px solid #ccc;
        position: relative;
        padding-bottom: 40px;
        background: #fff;
        margin: 20px 5px;
        .selectBox {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: flex-start;
          margin: 0 20px;
          max-height: 400px;
          overflow: scroll;
          .selectCell {
            width: 47%;
            padding: 8px 5px;
            margin: 8px 0;
            border: 1px solid #ccc;
            border-radius: 4px;
            cursor: pointer;
            display: flex;
            align-items: center;

            .keyvalFont {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              vertical-align: top;
            }
          }
          .labelChosen {
            color: #fff;
            background: #36aafd;
            border-color: #36aafd;
          }
        }
        .appendKeyval {
          display: block;
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          border-radius: 0;
        }
        .switchBar {
          display: flex;
          margin: 10px;
          .switchCell {
            flex: 1;
            border: 1px solid #ccc;
            line-height: 2.6rem;
            text-align: center;
            // height: 1.3rem;
            font-size: 1.15rem;
            color: #ccc;
          }
          .switchCellChosen {
            color: #fff;
            background: #409eff;
            border: 1px solid #409eff;
          }
        }
        .bgChooseBox {
          max-height: 500px;
          overflow: scroll;
          text-align: center;
          .bgCell {
            margin: 15px 10%;
            width: 80%;
            height: 80%;
            background: #ccc;
            background-size: cover;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            .contentInBg {
              width: 60%;
            }
            .toBlack {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.5);
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .diyBg {
            width: 80%;
            margin: 20px auto;
          }
        }
      }
      .showSide {
        width: 45%;
        height: auto;
        padding: 30px 20px;
        padding-bottom: 90px;
        min-height: 500px;
        background-color: #fff;
        border-radius: 20px !important;
        border: solid 1px #e6e6e6;
        margin: 20px 5px;
        max-width: 600px;
        min-width: 500px;
        text-align: center;
        position: relative;
        .inputBar {
          border-radius: 4px;
          .keyvalBar {
            display: flex;
            justify-content: space-between;
            padding: 10px 20px;
            font-size: 1.1rem;
            box-sizing: border-box;
            .label {
              width: 100px;
              line-height: 32px;
              text-align: left;
            }
            .content {
              flex: 1;
              text-align: left;
            }
            .inputValue {
              height: 32px;
              border: 1px solid #ccc;
              border-radius: 4px;
              position: relative;
              .selectIcon {
                font-size: 24rpx;
                position: absolute;
                right: 10px;
                top: 6px;
              }
            }
            .informationInput {
              font-size: 12px;
              height: 16px;
              border: none;
            }
          }
          .actBar {
            margin: 0;
            padding: 8px 0 8px 120px;
            text-align: left;
            background: #f1f1f1;
          }
        }
        .submitBtn {
          padding: 13px 30px !important;
          width: 54%;
          height: 50px;
          background-color: #ff962a !important;
          font-size: 18px;
          color: #ffffff !important;
          border-radius: 40px !important;
          box-shadow: 0px 5px 10px 0px #ff962a;
          position: absolute;
          bottom: 20px;
          left: 23%;
        }
        .submitBtn:hover {
          box-shadow: 0px 5px 10px 0px #fff;
        }
      }
    }
    .settingContainer {
      width: 60%;
      min-width: 700px;
      margin: 20px auto;
      border-radius: 4px;
      padding: 20px;
      background: #fff;
      .inputBar {
        margin: 20px 30px;
      }
      /deep/ .el-radio {
        margin: 6px 10px;
      }
      // /deep/ .el-input {
      //   width: 100px;
      // }
      .longElInput {
        width: 420px;
      }
    }
    .shareContainer {
      display: flex;
      align-content: space-between;
      align-items: flex-start;
      margin-top: 20px;
      // width: 60%;
      // min-width: 700px;
      // margin: 20px auto;
      // border-radius: 4px;
      // padding: 20px;
      // background: #fff;
      .urlSide {
        flex: 1;
      }
      .qrcodeSide {
        width: 40%;
        min-width: 200px;
        text-align: center;
      }
    }
  }
  .actBar {
    margin: 20px auto;
    text-align: center;
  }
}
::-webkit-scrollbar {
  width: 4px; /*对垂直流动条有效*/
  //   height: 10px; /*对水平流动条有效*/
}
/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 7px;
  //   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #e8e8e8;
}
.flip-list-move {
  transition: transform 0.3s;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
